module.exports = __webpack_public_path__ + "static/report-e97ea01ec6020926423dac6e1d170128.png";